import { createAsyncThunk } from "@reduxjs/toolkit";
import { ShadeMode } from "../state";


export const readShadeThunk = createAsyncThunk(
  'mode/load',
  async () => {
    const item = window.localStorage.getItem("mode");

    return (item === 'light') ? ShadeMode.Light : ShadeMode.Dark;
  }
);